<template>
  <div>
      <div>
        <div class="agreement-container">
          <h2 class="title">e农专家隐私政策</h2>
          <p style="float: right">生效日期：2023年4月18日</p>
          <p>&nbsp;</p>
          <p>欢迎使用“e农专家APP”提供的产品和服务！e农专家（或简称“我们”）深知个人信息对您的重要性，我们一向庄严承诺保护使用我们的产品和服务（以下统称“e农专家服务”）之用户（以下统称“用户”或“您”）的个人信息及隐私安全。您在使用e农专家服务时，我们可能会收集和使用您的相关个人信息（或简称“个人信息”）。</p>
          <p class="p-text">华农农服（北京）网络科技有限公司（开发者）非常重视您的个人信息，并让您对个人信息拥有控制权，我们会使用强大的加密技术来保护您的个人隐私，同时制定严格的政策来管理所有数据。</p>
          <p class="p-text">《e农专家隐私政策》（以下简称“本《隐私政策》”）适用于我们提供的所有e农专家服务。当您使用我们任何单项服务时，您同意接受本《隐私政策》以及我们在该单项服务中发出的特定隐私信息类政策条款（下列称“特定条款”）的保护，在此情况下特定条款与本《隐私政策》条款同时对您产生效力，未满十八周岁的用户，同时适用本《隐私政策》。如特定条款与本《隐私政策》条款存在同类条款的不一致约定，则在特定条款约束范围内应以特定条款为准。如我们提供的某一单项服务不适用本《隐私政策》的，该服务中会以适当方式明示排除适用本《隐私政策》。</p>
          <p>我们希望通过本《隐私政策》向您说明我们在收集和使用您相关个人信息时对应的处理规则，以及我们为您提供的访问、更正、删除和保护这些个人信息的方式，以便更好的保障您的权益。</p>
          <p class="p-text">【特别提示】请您在使用e农专家服务前，仔细阅读并了解本《隐私政策》（特别是加粗或下划线标注的内容），以做出适当选择。一旦您使用或在我们更新本《隐私政策》后继续使用我们的产品或服务，即意味着您同意本《隐私政策》并同意我们按照本《隐私政策》收集、使用、储存、分享、转让和披露您的相关个人信息。 </p>
          <p class="p-t">本《隐私政策》将帮助您了解以下内容：</p>
          <p class="p-t">一、我们如何收集和使用您的个人信息</p>
          <p class="p-t">二、我们如何使用COOKIES或同类技术</p>
          <p class="p-t">三、我们可能分享、转让和披露的个人信息</p>
          <p class="p-t">四、我们如何保留、储存和保护您的个人信息安全</p>
          <p class="p-t">五、如何管理您的个人信息 </p>
          <p class="p-t">六、第三方服务</p>
          <p class="p-t">七、未成年人保护</p>
          <p class="p-t">八、通知和修订</p>
          <p class="p-t">九、如何联系我们</p>
          <p class="bold">一、我们如何收集和使用您的个人信息</p>
          <p>我们收集您的个人信息主要是为了您和其他用户能够更容易和更满意地使用e农专家服务。而这些个人信息有助于我们实现这一目标。</p>
          <p>(一) 我们将通过以下途径收集和获得您的个人信息：</p>
          <p>1、您提供的个人信息。</p>
          <p>(1) 您在注册e农专家服务的账号或使用e农专家服务时，向我们提供的个人信息；</p>
          <p>(2) 您通过e农专家服务向其他方提供的共享个人信息，以及您使用e农专家服务时所储存的个人信息。</p>
          <p class="p-text">请注意，如您在e农专家服务中其他用户可见的公开区域内上传或发布的个人信息中、您对其他人上传或发布的信息作出的回应中公开您的个人信息，该等个人信息可能会被他人收集并加以使用。当您发现他人不正当地收集或使用您的个人信息时，您可以通过本《隐私政策》第九条【如何联系我们】约定的联系方式联络我们。</p>
          <p>2、其他方分享的您的个人信息。亦即其他方使用e农专家服务时所提供有关您的共享个人信息。</p>
          <p>3、我们获取的您的个人信息。您在使用e农专家服务时，我们收集、汇总、记录的个人信息。</p>
          <p>(二) 我们会出于以下目的，收集和使用您以下类型的个人信息：</p>
          <p>1、帮助您完成注册、登录及注销为便于我们为您提供e农专家完整的服务，您需要提供基本注册或登录个人信息，<span class="p-t">包括手机号码、电子邮箱地址，并创建您的账号、用户名和密码。</span>在部分单项服务中，如果您仅需使用浏览、查询、搜索等基本服务，您不需要注册成为e农专家用户及提供上述个人信息。</p>
          <p>在e农专家部分单项服务注册、登录或后续使用过程中，如果您提供其他额外个人信息（<span class="p-text">包括您的昵称、头像</span>），将有助于我们给您提供更优的服务体验，但如果您不提供这些个人信息，并不会影响您使用e农专家服务的基本功能。</p>
          <p><span class="p-t">如果您不再使用e农专家服务，在符合服务协议约定条件及国家相关法律法规规定的情况下，我们也提供注册账号的注销，您可以通过本《隐私政策》第九条【如何联系我们】约定的联系方式或各单项服务的具体指引进行操作。</span>当您的账号注销或被删除后，与该账号相关的e农专家服务项下的全部服务资料和数据将被删除或匿名化处理，但法律法规另有规定的除外。</p>
          <p>2、实现身份认证</p>
          <p>依照相关法律法规规定及监管要求，或为满足用户身份真实核验、保障系统和服务安全及其他特定服务功能等需要，<span class="p-text">我们可能需要您提供真实身份信息（包括姓名、身份证、护照、驾驶证、户口本、面部特征、指纹及其他身份信息）</span>以完成身份认证。如果您不提供上述信息，我们将不能向您提供相关的功能及服务。</p>
          <p>为实现身份认证的目的，<span class="p-t">您同意并授权我们可以自行或委托第三方向有关身份认证机构（如个人征信机构、政府部门等）提供、查询、核对您的前述身份信息。</span></p>
          <p>3、维护基础功能的正常运行</p>
          <p>在您使用我们服务过程中，为识别账号异常状态、了解产品适配性，向您提供浏览、搜索等基本服务，维护基础功能的正常运行，<span class="p-t">我们可能会自动收集、储存关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括：</span></p>
          <p class="p-t">(1) <span class="p-text">日志信息</span>：当您使用我们的服务时，我们可能会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。日志信息包括<span class="p-text">您的登录账号、搜索查询内容、IP地址、浏览器的类型、电信运营商、网络环境、使用的语言、访问日期和时间及您访问的网页浏览记录、Push打开记录、崩溃记录、停留时长、刷新记录、发布记录、关注、订阅、收藏及分享。</span></p>
          <p class="p-t">(2) <span class="p-text">设备信息</span>：我们可能会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息<span class="p-text">（包括IMEI、MAC、Serial、SIM卡IMSI识别码、设备机型、操作系统及版本、客户端版本、设备分辨率、包名、设备设置、进程及软件列表、唯一设备标识符、软硬件特征信息）、设备所在位置相关信息（包括IP 地址、GPS位置以及能够提供相关信息的WLAN接入点、蓝牙和基站传感器信息）。</span></p>
          <p class="p-t">同时为了收集上述基本的个人设备信息，我们将会申请访问您的设备信息的权限，我们收集这些信息是为了向您提供我们基本服务和基础功能，如您拒绝提供上述权限将可能导致您无法使用我们的产品与服务。</p>
          <p>4、向您提供商品或服务</p>
          <p>(1) 个人信息的分享与发布：您在使用e农专家服务时、上传和/或发布个人信息以及进行相关行为（例如您在e农专家部分服务中输入的待翻译文字、相关学习群内发发言、分享、商品/服务评价）时，我们将收集您上传、发布或形成的个人信息，并有权展示您的昵称、头像和发布内容。</p>
          <p>(2) 商品或服务交付：当您在我们的商品或服务中订购具体商品或服务时，我们会通过系统为您生成购买该商品或服务的订单。在部分服务项目中，为便于向您交付商品或服务，您可能需提供收货人<span class="p-text">个人身份信息、姓名、收货地址、邮政编码、收货人、联系电话、支付状态信息。</span>如果您拒绝提供此类个人信息，我们将无法完成相关交付服务。如您通过e农专家服务为其他人订购商品或服务，您需要提供该实际订购人的前述个人信息。<span class="p-text">向我们提供该实际订购人的前述个人信息之前，您需确保您已经取得其授权同意。在您使用e农专家部分服务特定功能时，e农专家将会收集、储存您上传的图片、文字、语音信息, 我们的相关识别程序会对这些数据进行处理分析并返回对应的文字结果。</span></p>
          <p>(3) 为完成订单支付、交付商品或服务、确认交易状态及为您提供售后与争议解决服务，<span class="p-t">我们会通过您基于交易所选择的交易对象、支付机构、物流公司等收集与交易进度相关的您的<span class="p-text">账号、订单、交易、支付、物流信息</span>，或将您的交易信息共享给上述服务提供者。</span></p>
          <p>(4) 订单管理：为展示您的账户的订单信息及保障您的售后权益，e农专家会收集您在使用e农专家过程中产生的<span class="p-text">订单信息、交易和消费记录、虚拟财产信息</span>用于向您展示及便于您对订单进行管理。</p>
          <p>(5) 客服与售后服务：<span class="p-n">当您联系我们的客服或使用其他用户响应功能时（包括提出售中售后申请、个人信息保护投诉或建议、其他客户投诉和需求），<span class="p-text">我们可能需要您提供必要的个人信息以匹配并核验您的用户身份</span>，以便保障您的账号与系统安全。<span class="p-text">我们可能还会保存您的联系方式（您与我们联系时使用的或您向我们主动提供的其他联系方式）、您与我们的通信/通话记录和内容、与您需求相关联的其他必要信息</span>，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</span>
          <p>5、我们通过间接方式收集到的您的个人信息：</p>
          <p><span class="p-t">我们可能从管理方、第三方合作伙伴获取您授权共享的相关个人信息。我们可能从第三方获取您授权共享的账户个人信息（头像、昵称、登录时间）并在您同意本《隐私政策》后将您的第三方账户与您的e农专家服务账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。</span>我们将在符合相关法律法规规定，并依据与关联方或第三方合作伙伴的约定、确信其提供的个人信息来源合法的前提下，收集并使用您的这些个人信息。</p>
          <p>6、为您提供安全保障</p>
          <p class="p-text">为提高您使用我们及合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或e农专家服务相关协议规则的情况，我们可能会收集、使用或整合您的账户信息、交易信息、设备信息、日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的个人信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</p>
          <p>7、改进我们的服务</p>
          <p>我们可能将通过某一项e农专家服务所收集的个人信息，用于我们的其他服务：在您使用某一项e农专家服务时所收集的您的个人信息，可能在另一项e农专家服务中用于向您提供特定内容或向您展示与您相关的、而非普遍的信息；我们可能让您参与有关e农专家服务的调查，帮助我们改善现有服务或设计新服务；同时，我们可能将您的个人信息用于软件更新。</p>
          <p class="p-text">您了解并同意，在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的个人信息将无法识别您的身份，在此情况下我们有权使用已经去标识化的个人信息，对用户数据库进行分析并予以商业化的利用。</p>
          <p>8、其他用途</p>
          <p class="p-text">请您注意，如果我们要将您的个人信息用于本《隐私政策》中未载明的其他用途或额外收集未提及的其他个人信息，我们会另行事先请您同意(确认同意的方式：勾选、弹窗、站内信、邮件、短信方式）。一旦您同意，该等额外用途将视为本《隐私政策》的一部分，该等额外个人信息也将适用本《隐私政策》。</p>
          <p>9、征得授权同意的例外</p>
          <p>根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：</p>
          <p>(1) 与国家安全、国防安全有关的；</p>
          <p>(2) 与公共安全、公共卫生、重大公共利益有关的；</p>
          <p>(3) 与犯罪侦查、起诉、审判和判决执行等有关的；</p>
          <p>(4) 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
          <p>(5) 所收集的个人信息是您自行向社会公众公开的；</p>
          <p>(6) 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
          <p>(7) 根据您的要求签订合同所必需的；</p>
          <p>(8) 用于维护e农专家服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
          <p>(9) 为合法的新闻报道所必需的；</p>
          <p>(10) 学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
          <p>(11) 法律法规规定的其他情形。</p>
          <p>10、您理解并同意，e农专家服务可能需要您在您的设备中开启特定的访问权限，以实现这些权限所涉及个人信息的收集和使用：</p>
          <p class="p-t">(1) 如我们访问您的位置信息，是为了根据您的位置信息为您提供更优质的页面展示和产品服务；</p>
          <p class="p-t">(2) 如我们访问您的摄像头，是为了使您可以使用摄像头进行扫码、拍摄，用于实现登录、支付、图片评论、拍照取词功能；</p>
          <p class="p-t">(3) 如我们访问您的相册，是为了使您可以实现您设备中的照片、图片或视频的取用与上传，便于您进行更换头像、发表评论/分享；</p>
          <p class="p-t">(4) 如我们访问您的麦克风，是为了使您可以实现语音翻译功能、与客服实现语音交互功能，在这些功能中我们会收集您的录音内容以识别您的具体需求；</p>
          <p>当您需要关闭该功能时，大多数移动设备都会支持您的这项需求，具体方法请参考或联系您移动设备的服务商或生产商。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的个人信息收集及使用。</p>
          <p>11、有关敏感个人信息的提示</p>
          <p class="p-text">以上由您提供或我们收集您的个人信息中，可能包含您的个人敏感信息，包括银行账号、交易和消费记录、虚拟财产信息、系统账号、邮箱地址及其有关的密码、电话号码、网页浏览记录、位置信息。请您谨慎并留意个人敏感信息，您同意您的个人敏感信息我们可以按本《隐私政策》所述的目的和方式来处理。</p>
          <p>12、自启动和关联启动</p>
          <p class="p-text">为了让您体验APP消息离线提醒功能，更全面体验APP功能，提供更优质的服务，在您同意本隐私政策后，APP在必要时，会开启自启动或关联启动功能。</p>
          <p>13、第三方SDK合作伙伴</p>
          <p>(1) 统计</p>
          <p>SDK 名称： Umeng统计</p>
          <p>第三方SDK公司名称：友盟同欣(北京)科技有限公司</p>
          <p>个人信息字段：设备信息 (IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM卡)IMSI 信息等</p>
          <p>隐私政策链接：https://www.umeng.com/page/policy</p>
          <br/>
          <br/>
          <br/>
          <p>(2) 推送</p>
          <p>SDK 名称：友盟推送SDK</p>
          <p>第三方SDK公司名称：深圳市腾讯计算机系统有限公司</p>
          <p>个人信息字段：设备信息(IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM 卡 IMSI 信息等)</p>
          <p>隐私政策链接：https://www.umeng.com/page/policy</p>
          <p>产品集成友盟+SDK及推送通道SDK(如小米、华为、oppo、vivo、魅族等)，推送通道SDK需要收集采集设备标识符(IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM 卡 IMSI 信息等)，用于唯一标识设备，以便向用户设备推送消息。采集地理位置甄别推送通道，提高消息推送的区域覆盖率</p>
          <br/>
          <br/>
          <br/>
          <p>(3) 推送-华为</p>
          <p>SDK 名称：华为推送 SDK</p>
          <p>第三方SDK公司名称：华为技术有限公司</p>
          <p>隐私政策链接：https://consumer.huawei.com/cn/legal/privacy-policy/</p>
          <p>SDK隐私安全说明：https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177</p>
          <br/>
          <br/>
          <br/>
          <p>(4) 推送-小米</p>
          <p>SDK 名称：小米推送 SDK</p>
          <p>第三方SDK公司名称：小米科技有限责任公司</p>
          <p>隐私政策链接：https://dev.mi.com/distribute/doc/details?pId=1352</p>
          <br/>
          <br/>
          <br/>
          <p>(5) 推送-VIVO</p>
          <p>SDK 名称：VIVO推送 SDK</p>
          <p>第三方SDK公司名称：维沃移动通信有限公司</p>
          <p>隐私政策链接：https://dev.vivo.com.cn/documentCenter/doc/652#w1-12075822</p>
          <br/>
          <br/>
          <br/>
          <p>(6) 推送-OPPO</p>
          <p>SDK 名称：OPPO推送 SDK</p>
          <p>第三方SDK公司名称：OPPO广东移动通信有限公司</p>
          <p>系统权限申请与使用说明：https://help.aliyun.com/document_detail/448507.html?spm=a2c4g.223595.0.0.7be622c6hgk5Wh</p>
          <br/>
          <br/>
          <br/>
          <p>(7) 图片加载</p>
          <p>SDK 名称：Glide</p>
          <p>SDK地址：https://github.com/bumptech/glide</p>
          <br/>
          <br/>
          <br/>
          <p>(8) 路由管理</p>
          <p>SDK 名称：ARouter</p>
          <p>SDK地址：https://github.com/alibaba/ARouter</p>
          <br/>
          <br/>
          <br/>
          <p>(9) 工具类库</p>
          <p>SDK 名称：AndroidUtilCode</p>
          <p>SDK地址：https://github.com/Blankj/AndroidUtilCode</p>
          <br/>
          <br/>
          <br/>
          <p>(10) 腾讯开放平台SDK</p>
          <p>SDK名称：微信登录、微信分享、微信支付</p>
          <p>隐私权政策链接：https://www.tencent.com/zh-cn/privacy-policy.html</p>
          <p class="bold">二、我们如何使用COOKIES或同类技术</p>
          <p>1. 在您未拒绝接受cookies的情况下，本应用会在您的计算机上设定或取用cookies ，以便您能登录或使用依赖于cookies的本应用平台服务或功能。</p>
          <p>2. 您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的本应用网络服务或功能。</p>
          <p>3.通过本应用所设cookies所取得的有关信息，将适用本政策。</p>
          <p class="bold">三、我们可能会分享、转让和披露您的个人信息</p>
          <p>在如下情况下，本应用将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>
          <p>1. 经您事先同意，向第三方披露；</p>
          <p>2.为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</p>
          <p>3. 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
          <p>4. 如您出现违反中国有关法律、法规或者本应用服务协议或相关规则的情况，需要向第三方披露；</p>
          <p>5. 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</p>
          <p>6. 在本应用平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，本应用有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。</p>
          <p>7. 其它本应用根据法律、法规或者网站政策认为合适的披露。</p>
          <p class="bold">四、我们如何保留、储存和保护您的个人信息安全</p>
          <p>(一) 我们仅在本《隐私政策》所述目的所必需期间和法律法规及监管规定的时限内保存您的个人信息。如我们终止服务或运营，我们将及时停止继续收集您个人信息的活动，同时会遵守相关法律法规要求提前向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理，法律法规或监管部门另有规定的除外。</p>
          <p class="p-t">(二) 我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内。以下情形除外：</p>
          <p>1、法律法规有明确规定；</p>
          <p>2、获得您的授权同意；</p>
          <p>3、您使用e农专家服务，且需要向境外传输您的个人信息完成交易的；</p>
          <p>针对以上情形，我们会确保依据本《隐私政策》及国家法律法规要求对您的个人信息提供足够的保护。</p>
          <p>(三) 我们非常重视个人信息安全，成立了专门的安全团队，并采取一切合理可行的措施，保护您的个人信息：</p>
          <p>1、数据安全技术措施</p>
          <p>我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失。网络服务采取了多种加密技术，例如在某些服务中，我们将利用加密技术（例如SSL）来保护您的个人信息，采取加密技术对您的个人信息进行加密保存，并通过隔离技术进行隔离。 在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用多种数据脱敏技术增强个人信息在使用中的安全性。采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。</p>
          <p>2、我们为保护个人信息采取的其他安全措施</p>
          <p>(1) 我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。</p>
          <p>(2) 我们通过个人信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。</p>
          <p>(3) 我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识和安全意识。</p>
          <p>(4) <span class="p-text">我们仅允许有必要知晓这些个人信息的我们及我们关联方的员工、合作伙伴访问您的个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您的个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与我们的合作关系。</span></p>
          <p>3、互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件或其他服务软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的个人信息安全。</p>
          <p>4、我们将尽力确保或担保您发送给我们的任何个人信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致个人信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
          <p>(四) 安全事件处置</p>
          <p>在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、短信、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
          <p class="p-text">请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证个人信息百分之百的安全。您需要了解，您接入e农专家服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。</p>
          <p class="bold">五、如何管理您的个人信息</p>
          <p>我们鼓励您更新和修改您的个人信息以使其更准确有效，也请您理解，<span class="p-t">您更正、删除、撤回授权或停止使用e农专家服务的决定，并不影响我们此前基于您的授权而开展的个人信息处理。</span>除法律法规另有规定，当您更正、删除您的个人信息或申请注销账号时，我们可能不会立即从备份系统中更正或删除相应的个人信息，但会在备份更新时更正或删除这些个人信息。</p>
          <p>您可以通过以下方式来管理您的个人信息：</p>
          <p>(一) 访问、更正和删除您的个人信息</p>
          <p>您能通过e农专家服务访问您的个人信息，并根据对应个人信息的管理方式自行完成或要求我们进行访修改、补充和删除。我们将采取适当的技术手段或提供提交申请的联系渠道，尽可能保证您可以访问、更新和更正自己的个人信息或使用e农专家服务时提供的其他个人信息。</p>
          <p>在访问、更正和删除前述个人信息时，我们可能会要求您进行身份验证，以保障个人信息安全。对于通过COOKIES或同类技术收集的您的个人信息，我们还在本《隐私政策》第二条“我们如何使用COOKIES或同类技术”部分说明了向您提供的选择机制。如果您无法通过上述路径访问、更正该等个人信息，您可以通过本《隐私政策》第九条【如何联系我们】约定的联系方式与我们取得联系。对于您在使用e农专家服务过程中产生的其他个人信息需要访问、更正或删除，我们会根据本《隐私政策》所列明的方式、期限及范围来响应您的请求。在部分个人信息删除时，我们可能会要求您进行身份验证，以保障个人信息安全。</p>
          <p>您随时可注销此前注册的账户，您可以通过以下方式进行操作： 进入个人中心-我的资料，点击【注销账号】，点击【确认继续】用验证码验证的方式可注销当前账号 在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求删除您的个人信息，法律法规另有规定的除外。</p>
          <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
          <p>1、如果我们处理个人信息的行为违反法律法规；</p>
          <p>2、如果我们收集、使用您的个人信息，却未征得您的授权同意；</p>
          <p>3、如果我们处理个人信息的行为严重违反了与您的约定；</p>
          <p>4、如果我们不再为您提供e农专家服务。</p>
          <p>若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</p>
          <p>(二) 公开与分享</p>
          <p>我们的多项服务可让您不仅与您的社交网络、也与使用该服务的所有用户公开分享您的相关个人信息，例如，您在e农专家服务中所上传或发布的个人信息、您对其他人上传或发布的个人信息作出的回应，通过电子邮件或在e农专家服务中不特定用户可见的公开区域内上传或公布您的个人信息，以及包括与这些个人信息有关的位置数据和日志信息。只要您不删除您所公开或共享的个人信息，有关个人信息可能一直留存在公众领域；即使您删除共享个人信息，有关个人信息仍可能由其他用户或不受我们控制的第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公众领域保存。<span class="p-text">如您将个人信息通过上述渠道公开或共享，由此造成您的个人信息泄露，我们不承担责任。因此，我们提醒并请您慎重考虑是否通过上述渠道公开或共享您的个人信息。</span></p>
          <p>(三) 改变您授权同意的范围</p>
          <p>您总是可以选择是否披露个人信息。有些个人信息是使用e农专家服务所必需的，但大多数其他个人信息的提供是由您决定的。您可以通过删除个人信息、关闭设备功能等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。</p>
          <p class="p-text">当您撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的个人信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
          <p class="bold">六、第三方服务</p>
          <p>e农专家服务可能链接至第三方提供的社交媒体或其他服务（包括网站或其他服务形式）。包括：</p>
          <p>(一) 您可利用“分享”键将某些内容分享到第三方平台，或您可利用第三方服务登录e农专家服务。这些功能可能会收集您的个人信息（包括您的日志信息），并可能在您的电脑装置COOKIES，从而正常运行上述功能；</p>
          <p>(二) 我们通过广告或我们服务的其他方式向您提供链接，使您可以接入第三方的服务或网站；</p>
          <p>(三) 其他接入第三方服务的情形。<span class="p-t">为实现本政策中声明的目的，我们可能会接入第三方服务商提供的SDK或其他类似的应用程序，并将我们依照本政策收集的您的某些信息共享给该等第三方服务商，以便提供更好的客户服务和用户体验。</span>目前，我们接入的第三方服务商主要包括以下几种类型：</p>
          <p class="p-text">1、 用于进行广告服务，包括广告展示、广告数据监测/统计；</p>
          <p class="p-text">2、 用于推送相关服务信息，包括手机厂商Push推送、特定事件提醒</p>
          <p class="p-text">3、  用于在您同意的情况下获取设备位置权限、搜集设备信息和日志信息；</p>
          <p class="p-text">4、 用于支付相关服务及汇总/统计支付信息：包括订单支付、交易行为核验、收入结算、支付信息汇总统计；</p>
          <p class="p-text">5、  用于第三方授权服务，包括本机一键登录、第三方账号登陆、将相关内容分享至第三方产品；</p>
          <p class="p-text">6、  用于支持产品功能模块，包括语音识别、翻译服务、在线直播、视频播放、连接智能硬件、客服；</p>
          <p class="p-text">7、  用于优化产品性能，包括统计数据崩溃信息。</p>
          <p class="p-text">如上所述服务由相关的第三方负责运营。您使用该等第三方服务（包括您向该等第三方提供的任何个人信息），须受第三方自己的服务条款及个人信息保护声明（而非本政策）约束，您需要仔细阅读其条款。我们仅会出于正当、必要、特定的目的共享您的信息。我们会要求他们履行相关保密义务并采取相应的安全措施。</p>

          <p class="bold">七、 未成年人信息的保护</p>
          <p>1. 我们非常重视对未成年人信息的保护。如果您是未满18周岁的未成年人，您的监护人需要仔细阅读本《隐私政策》并同意或授权您同意依照本《隐私政策》使用我们产品及/或服务。如果您是未满14周岁的未成年人，您的监护人需要仔细阅读本《隐私政策》并明示同意您依照本《隐私政策》使用我们产品及/或服务。</p>
          <p>2. 如果您/您的监护人不同意本《隐私政策》的任何内容，您应该立即停止使用我们产品及/或服务。</p>

          <p class="bold">八、通知和修订</p>
          <p class="p-text">我们可能适时修改本《隐私政策》的条款，该等修改构成本《隐私政策》的一部分。对于重大变更，我们会提供更显著的通知，您如果不同意该等变更，可以选择停止使用e农专家服务；如您仍然继续使用e农专家服务的，即表示同意受经修订的本《隐私政策》的约束。</p>
          <p>我们的任何修改都会将您的满意度置于首位。我们鼓励您在每次使用e农专家服务时都查阅我们的隐私政策。</p>
          <p class="p-text">我们可能在必需时（例如当我们由于系统维护而暂停某一项服务时）发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。</p>
          <p class="p-text">最后，您必须对您的账号和密码信息负有保密义务。任何情况下，请小心妥善保管。</p>
          <p class="bold">九、如何联系我们</p>
          <p>如您有关于个人信息安全的投诉和举报，或您对本《隐私政策》、您的个人信息的相关事宜有任何问题、意见或建议，以及有关本《隐私政策》或e农专家的隐私措施的问题，请与我们联系。邮箱地址：【enongye@aliyun.com】 一般情况下，我们将在收到您的问题、意见或建议之日起十五天内予以回复。</p>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  methods:{
      closeEvent(){
        window.opener=null;
        window.close();
      }
  }
}
</script>

<style lang="scss">

.agreement-container{
  margin-top: 21px;
  border: 1px #e4e4e4 solid;
  background: #fff;
  padding: 0 40px 0 40px;
  p{
    line-height: 30px;
    font-size:14px;
    color:#666;
    word-break: break-all;
  }
  h2{
    padding:60px 0 40px;
    text-align: center;
    font-family:微软雅黑 Bold, 微软雅黑 Regular, 微软雅黑;
    font-weight: 700;
    font-size: 20px;
  }
  .bold{
    font-family:微软雅黑 Bold, 微软雅黑 Regular, 微软雅黑;
    font-weight:700;
    color:#1ABC9C;
    line-height: 76px;
  }

  .p-text {
    text-decoration:underline;
    font-size:14px;
    font-weight:bold;
  }
  .p-t {
    font-size:14px;
    font-weight:bold;
  }

  .p-n {
    text-decoration:underline;
  }
}
.link{
  cursor: pointer;
  .fa-close{
    margin-right: 5px;
    font-size: 16px;
    color: #1ABC9C;
  }
}
</style>
